import "./tarifsDefault.css";
import TarifsTextTitle from "./components/tarifsTextTitle";
import TarifsTextContent from "./components/tarifsTextContent";

import TarifsTextDeroulement from "./components/tarifsTextDeroulement";
import TarifsTextNotes from "./components/tarifsTextNotes";

function TarifsDust() {
  const descriptionList = [
    "La poussière accumulée dans un ordinateur peut entraîner une surchauffe, réduire les performances et endommager les composants.",
    "Un entretien régulier permet d'optimiser le refroidissement, de prolonger la durée de vie de l'appareil et de limiter les risques de pannes.",
    "Ce service comprend le nettoyage du ventilateur, des radiateurs, de la carte mère et des autres composants internes.",
  ];
  const deroulementList = [
    "1 Diagnostic initial : Vérification de la température du processeur et de l'état général du système de refroidissement.",
    "2 Démontage sécurisé : Ouverture du boîtier ou du capot inférieur de l'ordinateur pour accéder aux composants internes.",
    "3 Nettoyage minutieux : Dépoussiérage à l'air comprimé et brossage doux des éléments sensibles (ventilateurs, radiateurs, carte mère…).",
    "4 Changement de pâte thermique : Remplacement de la pâte thermique usée du processeur et/ou de la carte graphique.",
    "5 Remontage et test final : Fermeture de l'appareil et test des températures pour s'assurer d'un bon fonctionnement.",
  ];
  return (
    <div className="tarifs-text-main-contenair">
      <TarifsTextTitle
        title="DÉPOUSSIÈRAGE"
        price="40€ TTC"
        atelier={true}
        domicile={true}
        time="45min - 1h30"
      />
      <div className="tarifs-text-main">
        <div className="tarifs-text-colA">
          <TarifsTextContent content={descriptionList} h="100%" />
        </div>
        <div className="tarifs-text-colB">
          <TarifsTextDeroulement operations={deroulementList} />
        </div>
      </div>
      <TarifsTextNotes notes="Si votre ordinateur est vraiment dans un mauvais état et nécessite bien plus d'une heure de nettoyage cela entrainera des frais supplémentaires." />
    </div>
  );
}

export default TarifsDust;
